// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
var Chartist = require("chartist");

var options = {
  axisX: {
    offset: 30,
    showLabel: true,
    showGrid: false
  },
  axisY: {
    offset: 40,
    showLabel: true,
    showGrid: true,
    onlyInteger: true,
    labelInterpolationFnc: function(value) {
      var text = value < 0 ? "-$" + Math.abs(value) : "$" + value;
      if (value !== 0) {
        return text;
      } else {
        return value;
      }
    }
  },
  chartPadding: {
    top: 15,
    right: 15,
    bottom: 5,
    left: 0
  },
  referenceValue: 0
};

var data = window.earningsData.slice(-5);
var labels = data.map(d => d.quarter == 1 ? `Q${d.quarter} '${d.year - 2000}` : "Q" + d.quarter);

var revenuedata = {
  labels,
  series: [
    data.map(d => d.revenue)
  ]
};

var profitdata = {
  labels,
  series: [
    data.map(d => d.pl)
  ]
};

var earningsdata = {
  labels,
  series: [
    data.map(d => d.earnings)
  ]
}

var revenue = new Chartist.Bar('#chart1', revenuedata, options);
var profit = new Chartist.Bar('#chart2', profitdata, options);
var earnings = new Chartist.Bar('#chart3', earningsdata, options);

var ondraw = function(data) {

  if (data.type == "grid" && data.axis.ticks[data.index] === 0) {
    data.element.addClass("axis");
  };
  if (data.type === "bar") {
    var barEnd = data.y2 - 6;
    var barEndNegative = data.y2 + 12;
    var labelX = data.x1;// + (data.element.width() / 2);
    var value = data.element.attr('ct:value') * 1;
    if (value < 0) {
      data.element.addClass("negative");
    }

    var label = new Chartist.Svg('text');
    var text = value < 0 ? "-$" + Math.abs(value).toFixed(2) : "$" + value.toFixed(2);
    label.text(text);
    label.addClass("ct-barlabel");
    if (value > 0) {
      label.attr({
        x: labelX,
        y: barEnd,
        'text-anchor': 'middle'
      });
      return data.group.append(label);
    } else if (value < 0) {
      label.attr({
        x: labelX,
        y: barEndNegative,
        'text-anchor': 'middle'
      });
      return data.group.append(label);
    }
  }
}

profit.on('draw', ondraw);
revenue.on('draw', ondraw);
earnings.on('draw', ondraw);
